module.exports = __webpack_public_path__ + "img/award__sku.eb777c4.png";